import { carrierDetail } from '@/api/modules/carrier.js'
export default {
    data(){
        return {
            detailObj:null,
        }
    },
    mounted(){
        const { type, id } = this.$route.query;
        carrierDetail(type, id).then(({result})=>{
            if (result) {
                this.detailObj=result || {};
            }
            
        })
    }
}